"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function padLeft(number, length) {
    if (length === void 0) { length = 2; }
    var paddedNumber = String(number);
    while (paddedNumber.length < length) {
        paddedNumber = "0" + paddedNumber;
    }
    return paddedNumber;
}
function isNumeric(input) {
    return !isNaN(parseFloat(input)) && isFinite(input);
}
function TimeSpan(time) {
    if (!isNumeric(time)) {
        return;
    }
    var milliseconds = Math.round(+time * 1000);
    var hours = Math.floor(milliseconds / (3600 * 1000));
    var minutes = Math.floor((milliseconds % (3600 * 1000)) / (60 * 1000));
    var seconds = Math.floor((milliseconds % 60000) / 1000);
    milliseconds %= 1000;
    return padLeft(hours) + ":" + padLeft(minutes) + ":" + padLeft(seconds) + "." + padLeft(Math.round(Math.abs(milliseconds / 10)));
}
exports.default = TimeSpan;
//# sourceMappingURL=timespan.js.map